import { icons } from "./constants";

export const alertGenericError = () =>
    Swal.fire({
        icon: icons.error,
        title: "Ocurrió un error inesperado", // 💔
        html: "Si el problema persiste, favor de reportarlo a soporte.",
        cancelButtonText: "Cerrar",
        showCancelButton: true,
        showConfirmButton: false,
    });
